import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getStepDetails } from 'visa-store';
import * as i3 from 'app-services-library';
import * as i4 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class VdTextAreaService {
    constructor() { }
}
VdTextAreaService.ɵfac = function VdTextAreaService_Factory(t) { return new (t || VdTextAreaService)(); };
VdTextAreaService.ɵprov = i0.ɵɵdefineInjectable({ token: VdTextAreaService, factory: VdTextAreaService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdTextAreaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function VdTextAreaComponent_em_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 8);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function VdTextAreaComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, " Required");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} }
function VdTextAreaComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Minimum length is ", ctx_r2.inputParams == null ? null : ctx_r2.inputParams.minLength, "");
} }
function VdTextAreaComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Maximum length is ", ctx_r3.inputParams == null ? null : ctx_r3.inputParams.maxLength, "");
} }
class VdTextAreaComponent {
    constructor(fb, store, appServicesLibraryService) {
        this.fb = fb;
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.userType = '';
    }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f, _g;
        this.userType = sessionStorage.getItem('userTypeRole');
        const textAreaValidators = this.inputParams.mandatory ? [Validators.required] : [];
        if (((_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.mandatory) && ((_b = this.inputParams) === null || _b === void 0 ? void 0 : _b.minLength)) {
            textAreaValidators.push(Validators.minLength(this.inputParams.minLength));
        }
        if (((_c = this.inputParams) === null || _c === void 0 ? void 0 : _c.mandatory) && ((_d = this.inputParams) === null || _d === void 0 ? void 0 : _d.maxLength)) {
            textAreaValidators.push(Validators.maxLength(this.inputParams.maxLength));
        }
        let initialValue = Array.isArray((_e = this.inputParams) === null || _e === void 0 ? void 0 : _e.value) ? '' : (_f = this.inputParams) === null || _f === void 0 ? void 0 : _f.value;
        if (this.inputParams.stepName && this.inputParams.stepName == 'Send Receipt') {
            initialValue = '';
        }
        this.group.addControl(this.inputParams.name, this.fb.control(initialValue, textAreaValidators));
        this.valueChangesSubscription = (_g = this.group.get(this.inputParams.name)) === null || _g === void 0 ? void 0 : _g.valueChanges.subscribe(() => {
            const control = this.group.get(this.inputParams.name);
            control === null || control === void 0 ? void 0 : control.updateValueAndValidity();
            control === null || control === void 0 ? void 0 : control.markAsTouched();
        });
        if (this.inputData) {
            this.toggleInputFields();
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.toggleInputFields();
            });
        }
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    toggleInputFields() {
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
            this.group.disable();
        }
        else {
            this.group.enable();
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        if (this.valueChangesSubscription) {
            this.valueChangesSubscription.unsubscribe();
        }
    }
}
VdTextAreaComponent.ɵfac = function VdTextAreaComponent_Factory(t) { return new (t || VdTextAreaComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.AppServicesLibraryService)); };
VdTextAreaComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdTextAreaComponent, selectors: [["vd-text-area"]], inputs: { inputParams: "inputParams", group: "group", formControlName: "formControlName", inputData: "inputData" }, decls: 11, vars: 10, consts: [[3, "formGroup"], [1, "text-field"], [1, "p-0", "m-0", 3, "ngStyle"], [1, "p-0", "m-0"], [1, "label-cls", "d-block", "common-bene-class-for-translation"], ["class", "error", 4, "ngIf"], ["rows", "2", 1, "textAreaWidth", "form-control", 3, "formControlName", "placeholder"], [4, "ngIf"], [1, "error"]], template: function VdTextAreaComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "label", 4);
        i0.ɵɵtext(5);
        i0.ɵɵtemplate(6, VdTextAreaComponent_em_6_Template, 2, 0, "em", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "textarea", 6);
        i0.ɵɵtemplate(8, VdTextAreaComponent_span_8_Template, 3, 0, "span", 5);
        i0.ɵɵtemplate(9, VdTextAreaComponent_ng_container_9_Template, 4, 1, "ng-container", 7);
        i0.ɵɵtemplate(10, VdTextAreaComponent_ng_container_10_Template, 4, 1, "ng-container", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_7_0 = null;
        let tmp_7_1 = null;
        let tmp_8_0 = null;
        let tmp_9_0 = null;
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", ctx.inputParams == null ? null : ctx.inputParams.style);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.inputParams == null ? null : ctx.inputParams.properties == null ? null : ctx.inputParams.properties.textArealabel, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate1("placeholder", "Enter ", (ctx.inputParams == null ? null : ctx.inputParams.properties == null ? null : ctx.inputParams.properties.placeholder) ? ctx.inputParams.properties == null ? null : ctx.inputParams.properties.placeholder : "", "");
        i0.ɵɵproperty("formControlName", ctx.formControlName);
        i0.ɵɵattribute("maxlength", (ctx.inputParams == null ? null : ctx.inputParams.maxLength) > 0 ? ctx.inputParams == null ? null : ctx.inputParams.maxLength : null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && (ctx.group == null ? null : (tmp_7_0 = ctx.group.get(ctx.inputParams == null ? null : ctx.inputParams.name)) == null ? null : tmp_7_0.touched) && (ctx.group == null ? null : (tmp_7_0 = ctx.group.get(ctx.inputParams == null ? null : ctx.inputParams.name)) == null ? null : tmp_7_0.value == null ? null : (tmp_7_1 = tmp_7_0.value.toString()) == null ? null : tmp_7_1.trim()) === "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.minLength) !== null && (ctx.group == null ? null : (tmp_8_0 = ctx.group.get(ctx.inputParams == null ? null : ctx.inputParams.name)) == null ? null : tmp_8_0.value == null ? null : tmp_8_0.value.length) < (ctx.inputParams == null ? null : ctx.inputParams.minLength) && (ctx.group == null ? null : (tmp_8_0 = ctx.group.get(ctx.inputParams == null ? null : ctx.inputParams.name)) == null ? null : tmp_8_0.touched));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.maxLength) !== null && (ctx.inputParams == null ? null : ctx.inputParams.maxLength) > 0 && (ctx.group == null ? null : (tmp_9_0 = ctx.group.get(ctx.inputParams == null ? null : ctx.inputParams.name)) == null ? null : tmp_9_0.value == null ? null : tmp_9_0.value.length) > (ctx.inputParams == null ? null : ctx.inputParams.maxLength));
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupDirective, i4.NgStyle, i4.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.FormControlName, i1.MaxLengthValidator], styles: [".textAreaWidth[_ngcontent-%COMP%]{width:100%;resize:none}.text-field[_ngcontent-%COMP%]{margin-bottom:15px}.error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdTextAreaComponent, [{
        type: Component,
        args: [{
                selector: 'vd-text-area',
                templateUrl: 'vd-text-area.component.html',
                styleUrls: ['vd-text-area.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.Store }, { type: i3.AppServicesLibraryService }]; }, { inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], inputData: [{
            type: Input
        }] }); })();

class VdTextAreaModule {
}
VdTextAreaModule.ɵfac = function VdTextAreaModule_Factory(t) { return new (t || VdTextAreaModule)(); };
VdTextAreaModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdTextAreaModule });
VdTextAreaModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdTextAreaModule, { declarations: [VdTextAreaComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule], exports: [VdTextAreaComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdTextAreaModule, [{
        type: NgModule,
        args: [{
                declarations: [VdTextAreaComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [VdTextAreaComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-text-area
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdTextAreaComponent, VdTextAreaModule, VdTextAreaService };
//# sourceMappingURL=vd-text-area.js.map
